import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { Constants } from '../../shared/models/constants';
import { Enums } from '../../shared/models/enums';
import { CellRendererElementSubTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element-Subtype.enum';
import { CellRendererElementTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class EdgeExpertsGridService {
    constructor() { }
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    private callbackProjDOcUploadModalClose = new Subject<any>(); // Source
    eventCallbackProjDocuUploadModalClose$ = this.callbackProjDOcUploadModalClose.asObservable(); // Stream

    cols: Array<TableColumn> = [
        {
            field: '',
            header: 'Checkbox',
            pinned: true,
            columnCheckBox: true,
            style: { 'width': '50px', 'min-width': '50px', 'max-width': '50px' }
        },
        {
            field: 'email',
            header: 'EDGE Applicant Email',
            pinned: true,
            sort: true,
            sortName: 'email',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'edgeUserEmail',
            header: 'EDGE Account Email',
            sort: true,
            sortName: 'edgeUserEmail',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'edgeExpertEmail',
            header: 'EDGE Expert Email',
            pinned: false,
            sort: true,
            sortName: 'edgeExpertEmail',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onEdgeExpertEmailclick'
            }
        },
        {
            field: 'firstName',
            header: 'First Name',
            pinned: false,
            sort: true,
            sortName: 'firstName',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'lastName',
            header: 'Last Name',
            sort: true,
            sortName: 'lastName',
            filter: { type: FilterTypes.text }
        }, {
            field: 'gender',
            header: 'Gender',
            sort: true,
            sortName: 'Gender',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Female', value: 'Female' },
                    { label: 'Male', value: 'Male' },
                    { label: 'Other', value: 'Other' },
                    { label: 'Prefer not to answer', value: 'Prefer not to answer' }
                ]
            }
        },
        {
            field: 'epin',
            header: 'EPIN',
            sort: true,
            sortName: 'epin',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'candidateType',
            header: 'Applicant Type',
            sort: true,
            sortName: 'candidateType',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'trainingOrganization',
            header: 'Training Organization',
            sort: true,
            sortName: 'trainingOrganization',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'CAMACOL', value: 'CAMACOL' },
                    { label: 'CEDBIK', value: 'CEDBIK' },
                    { label: 'GBC Costa Rica', value: 'GBC Costa Rica' },
                    { label: 'GBC Indonesia', value: 'GBC Indonesia' },
                    { label: 'GBC South Africa', value: 'GBC South Africa' },
                    { label: 'GBCI', value: 'GBCI' },
                    { label: 'IFC', value: 'IFC' },
                    { label: 'PGBI', value: 'PGBI' },
                    { label: 'SGS Vietnam', value: 'SGS Vietnam' },
                    { label: 'Sintali-SGS', value: 'Sintali-SGS' },
                    { label: 'Other', value: 'Other' }
                ]
            }
        },
        {
            field: 'edgeFaculty1',
            header: 'EDGE Faculty',
            sort: true,
            sortName: 'edgeFaculty1',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'edgeFaculty2',
            header: 'EDGE Second Faculty',
            sort: true,
            sortName: 'edgeFaculty2',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'eligibilityId',
            header: 'Eligibility ID',
            sort: true,
            sortName: 'eligibilityId',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'licenseId',
            header: 'License Id',
            sort: true,
            sortName: 'licenseId',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'examVersion',
            header: 'Exam Version',
            sort: true,
            sortName: 'examVersion',            
        },
        {
            field: 'examDate',
            header: 'Exam Date',
            sort: true,
            sortName: 'examDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'country',
            header: 'Country',
            sort: true,
            sortName: 'country',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'city',
            header: 'City',
            sort: true,
            sortName: 'city',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'certificateType',
            header: 'Mode of Generation',
            sort: true,
            sortName: 'certificateType',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'agreementSignedDate',
            header: 'Agreement Signed Date',
            sort: true,
            sortName: 'agreementSignedDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'licenseGeneratedDate',
            header: 'License Generated Date',
            sort: true,
            sortName: 'licenseGeneratedDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'lastActivity',
            header: 'Last Activity',
            sort: true,
            sortName: 'lastActivity',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'certificateId',
            header: 'Download',
            displayName: ' ',
            isEnable: 'certificateId',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDownloadCertificateClick',
                elementsubType: CellRendererElementSubTypes.download,
            }
        }
        
    ];

    savingsCellRenderer(rowData, field) {
        if (rowData[field]) {
            const percent = parseFloat(rowData[field].replace('%', ''));
            if (!Number.isNaN(percent) && percent >= 20) {
                return `<div class="text-green text-truncate" title="` + rowData[field] + `">` + rowData[field] + `</div>`;
            } else {
                return rowData[field];
            }
        } else {
            return '';
        }
    }
    dateCellRenderer(rowData, field) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], Constants.DATETIME_FORMAT, 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    fixedTo2Decimal(rowData, field) {
        if (rowData[field]) {
            const value = parseFloat(rowData[field]);
            return (!Number.isNaN(value)) ? 
            `<div class="text-truncate" title="` + value.toFixed(2) + `">` + value.toFixed(2) + `</div>` : rowData[field];
        } else {
            return '';
        }

    }

    notifyProjectNameCellRenderer(rowData: any) {
        return rowData.notify ? `<span class="grid-cell-notification me-1"><i class="fas fa-circle text-buttercup"></i></span>` : '';
    }

    getDefaultColumns(columns: any[] = [], role = '') {
        let col = [];
        columns =  [
            '', 'email', 'edgeUserEmail', 'edgeExpertEmail', 'firstName',
            'lastName', 'gender', 'epin', 'candidateType', 'trainingOrganization', 'edgeFaculty1', 'edgeFaculty2', 'eligibilityId', 'licenseId','examVersion', 'examDate',
            'country', 'city', 'certificateType', 'agreementSignedDate', 'licenseGeneratedDate', 'lastActivity', 'certificateId'
        ]; 
        if (!columns) {
            return this.cols;
        }
        const newColumns = _.cloneDeep(this.cols);
        col = _.filter(newColumns, (v) => _.includes(columns, v.field));
        col.find(item => item.field === 'edgeExpertEmail').cellRenderer['renderEventBeforeHtml'] = this.notifyProjectNameCellRenderer;
        return col;
    }
}

